import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../utils/api";
import EditLinkModal from "../components/EditLinkModal";

export default function LinkEditPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [link, setLink] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let alive = true;

    async function fetchLink() {
      try {
        setLoading(true);
        const data = await api.getLink(id);
        if (!alive) return;
        setLink(data.link || data);
      } catch (err) {
        if (!alive) return;
        setError(err.message || "Failed to load link");
      } finally {
        if (alive) setLoading(false);
      }
    }

    fetchLink();

    return () => {
      alive = false;
    };
  }, [id]);

  useEffect(() => {
    document.title = loading ? "Loading Link - LinkSquire" : error ? "Link not found - LinkSquire" : "Edit Link - LinkSquire";
  }, [loading, error]);

  if (loading) {
    return (
      <div className="edit-fullscreen" style={{ alignItems: "center", justifyContent: "center" }}>
        <div className="loading-state">
          <div className="spinner" />
          <p>Loading link...</p>
        </div>
      </div>
    );
  }

  if (error || !link) {
    return (
      <div className="edit-fullscreen" style={{ alignItems: "center", justifyContent: "center" }}>
        <div className="campaign-links-empty" style={{ maxWidth: 560 }}>
          <h3>Link not found</h3>
          <p>{error || "The link you are trying to edit could not be loaded."}</p>
          <button className="btn-primary" onClick={() => navigate(-1)}>
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return (
    <EditLinkModal
      link={link}
      onClose={() => navigate(-1)}
      onUpdated={() => {
        navigate(-1);
      }}
    />
  );
}